import { render, staticRenderFns } from "./BateriasAdmin.vue?vue&type=template&id=2ae5f672&"
import script from "./BateriasAdmin.vue?vue&type=script&lang=js&"
export * from "./BateriasAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BateriasAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports